module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "manager-track-report center-panel report"
  }, [_c('md-content', {
    directives: [{
      name: "loader-overlay",
      rawName: "v-loader-overlay",
      value: (_vm.progress),
      expression: "progress"
    }],
    staticClass: "md-elevation-1",
    attrs: {
      "md-theme": "white"
    }
  }, [_c('sort-table', {
    attrs: {
      "columns": _vm.tableColumns,
      "per-page": _vm.perPage,
      "total": _vm.reportsAmount,
      "table-id": "report",
      "default-order": "desc",
      "default-sort": "id",
      "showAddButton": false
    },
    on: {
      "refresh": _vm.getReports
    },
    model: {
      value: (_vm.reports),
      callback: function($$v) {
        _vm.reports = $$v
      },
      expression: "reports"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd2c380a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/reports/views/DispatcherReport.vue
// module id = 1250
// module chunks = 0